/** @jsxRuntime classic */
import React from "react";
import { useParams } from "react-router";

import { View } from "./View";
import { useThis } from "./useThis";

import type { FC } from "react";

type Params = {
  orderId: string;
  lineItemId: string;
};

export const DigitalContentDownload: FC = () => {
  const parameters = useParams<Params>();
  const props = useThis({ parameters });

  return <View {...props} />;
};
